import Profile from 'components/profiles'
import { isEmpty } from 'lodash'

export const genericProfileRoutes = namePrefix => {
  return [
    {
      path: 'payment-details',
      name: `${namePrefix}.payment-details`,
      component: Profile.ProfilePaymentDetails
    },
    {
      path: 'card-details',
      name: `${namePrefix}.card-details`,
      component: Profile.ProfileCardDetails
    },
    {
      path: 'profile-images',
      name: `${namePrefix}.images`,
      component: Profile.ProfileGenericProfileImage
    }
  ]
}

export const talentProfileRoutes = namePrefix => {
  return [
    {
      path: 'description',
      name: `${namePrefix}.description`,
      component: Profile.ProfileTalentDescription
    },
    {
      path: 'known-for',
      name: `${namePrefix}.known-for`,
      component: Profile.ProfileTalentKnownFor
    },
    {
      path: 'industries',
      name: `${namePrefix}.industries`,
      component: Profile.ProfileTalentIndustries
    },
    {
      path: 'interests/:page(interests|specialist|personal)?',
      name: `${namePrefix}.interests`,
      component: Profile.ProfileInterestTags,
      props: true,
      meta: {
        pace (to, from) {
          if (isEmpty(from.matched)) {
            return true
          } else if (to.params.page !== undefined || !isEmpty(to.query)) {
            return false
          }

          return true
        }
      }
    },
    {
      path: 'career',
      name: `${namePrefix}.career`,
      component: Profile.ProfileCareerTags
    },
    {
      path: 'charities-and-sponsors',
      name: `${namePrefix}.charity-and-sponsor`,
      component: Profile.ProfileTalentCharitiesAndSponsors
    },
    {
      path: 'themes',
      name: `${namePrefix}.themes`,
      component: Profile.ProfileTalentThemes,
      meta: {
        permissions: ['admin', 'restricted-admin', 'intern', 'regional-admin', 'super-regional-admin', 'manager']
      }
    },
    {
      path: 'based-in',
      name: `${namePrefix}.locations`,
      component: Profile.ProfileTalentLocations
    },
    {
      path: 'profile-image',
      name: `${namePrefix}.image`,
      component: Profile.ProfileTalentProfileImage
    },
    {
      path: 'availability',
      name: `${namePrefix}.availability`,
      component: Profile.ProfileTalentAvailability
    },
    {
      path: 'endorsements',
      name: `${namePrefix}.endorsements`,
      component: Profile.ProfileTalentEndorsementsList,
      meta: {
        permissions: ['admin', 'restricted-admin', 'intern', 'regional-admin', 'super-regional-admin']
      }
    },
    {
      path: 'packages',
      name: `${namePrefix}.packages`,
      component: Profile.ProfileTalentPackages,
      meta: {
        permissions: ['admin', 'restricted-admin', 'intern', 'talent', 'manager', 'regional-admin', 'super-regional-admin']
      }
    }
  ]
}
